// extracted by mini-css-extract-plugin
export default {"modalOverlay":"IK-z","modalContent":"JK-z","header":"KK-z","close":"LK-z"};